import { IUserPreferenceGeneralListItemType } from '@user/store/userPreferences/userPreferencesGeneral'
import { EntityType } from './types'

export const MAX_VISIBLE_CHIPS = 4
export const MINIMUM_RECORD_TYPE_COUNT = 1

export const RECORD_TYPES: ReadonlyArray<{ key: EntityType; label: string }> = [
  { key: 'draftlead', label: 'Pending Leads' },
  { key: 'lead', label: 'Leads' },
  { key: 'opportunity', label: 'Opportunities' },
]

export const RECORD_TYPE_LABELS: Record<EntityType, string> =
  RECORD_TYPES.reduce(
    (acc, { key, label }) => {
      acc[key] = label
      return acc
    },
    {} as Record<EntityType, string>,
  )

export const PREF = {
  entityTypes: IUserPreferenceGeneralListItemType.MapViewFilteredEntityTypes,
  myRecords: IUserPreferenceGeneralListItemType.MapViewFilteredMyRecords,
  knockStatuses:
    IUserPreferenceGeneralListItemType.MapViewFilteredKnockStatuses,
} as const

export const SX = {
  chip: {
    fontWeight: 400,
    fontSize: 14,
    border: '1px solid #1565C0',
    background: '#D4E3F3',
  },
  alert: {
    background: '#ECF5FF',
    color: '#22548C',
    fontWeight: 500,
    pointerEvents: 'auto' as const,
    alignItems: 'flex-start' as const,
  },
  alertWidth: {
    width: {
      xs: 'min(calc(100vw - 32px), 320px)',
      sm: 360,
      lg: 360,
    },
    maxWidth: 'calc(100vw - 32px)',
  },
  paper: {
    p: 0,
    display: 'inline-block',
    pointerEvents: 'auto' as const,
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
  alertTitle: {
    fontWeight: 600,
    fontSize: '16px',
    mb: 0,
  },
} as const
